import { __rest, __awaiter } from '../../node_modules/tslib/tslib.es6.js';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
import { useState, useRef, useEffect } from 'react';
import { useDelayedRedirect } from './useDelayedRedirect.js';

const useJoinBrandClub = (brand, handleJoinClub) => {
    const [joinedState, setJoinedState] = useState((brand === null || brand === void 0 ? void 0 : brand.isMember) ? 'joined' : 'not_join');
    const campaignRewards = _orderBy(_get(brand, ['campaignRewards']), ['rewardAmount'], ['desc']);
    const handleJoinError = (errorMessage) => {
        console.error('join club error: ', errorMessage);
        setJoinedState('not_join');
    };
    const handleJoin = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!(brand === null || brand === void 0 ? void 0 : brand.brandclubId)) {
            handleJoinError('brandclubId is not defined');
            return;
        }
        (_a = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(e);
        (_b = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _b === void 0 ? void 0 : _b.call(e);
        try {
            setJoinedState('joining');
            const campaignId = _get(campaignRewards, ['0', 'campaignId'], undefined);
            const res = yield (handleJoinClub === null || handleJoinClub === void 0 ? void 0 : handleJoinClub(brand.brandclubId, campaignId));
            if (res === 'success') {
                setJoinedState('joined');
            }
            else {
                handleJoinError('Unknown error');
            }
        }
        catch (e) {
            if (e instanceof Error) {
                handleJoinError(e.message);
            }
            else {
                handleJoinError('Unknown error');
            }
        }
    });
    return {
        joinedState,
        handleJoin,
        campaignRewards,
    };
};
const useJoinBrandClubWithRedirect = ({ brand, handleJoinClub, link, delay = 500, navigate, }) => {
    const _a = useJoinBrandClub(brand, handleJoinClub), { joinedState, handleJoin } = _a, rest = __rest(_a, ["joinedState", "handleJoin"]);
    const prevJoinedStateRef = useRef(joinedState);
    const delayedRedirect = useDelayedRedirect(navigate, delay);
    const brandId = brand === null || brand === void 0 ? void 0 : brand.brandId;
    useEffect(() => {
        // only redirect if we went from joining to joined
        if (brandId && prevJoinedStateRef.current === 'joining' && joinedState === 'joined') {
            delayedRedirect(link || `/joinclubsuccess/${brandId}`);
        }
        prevJoinedStateRef.current = joinedState;
    }, [joinedState, delayedRedirect, link, brandId]);
    return Object.assign({ joinedState,
        handleJoin }, rest);
};

export { useJoinBrandClub, useJoinBrandClubWithRedirect };
//# sourceMappingURL=useJoinBrandClub.js.map
